import { api } from "@data-phone/react-resource-server-auth";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading, setIntegrations, setIntegrationConfig, setError } from "../redux/slices/integrations.slice";
import { useApiQuery } from "../hooks/useApiQuery";

export interface Integration {
    name: string;
    config: Record<string, any>;
}

export interface IntegrationConfig {
    name: string;
    config: Record<string, any>;
}


export const fetchIntegrations = async (): Promise<string[]> => {
    try {
        const response = await api.get(
            `${process.env.REACT_APP_API_BASE_URL}/integrations/integrations`
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching integrations:", error);
        return [];
    }
};

export const fetchIntegrationConfig = async (integrationName: string): Promise<IntegrationConfig> => {
    try {
        const res = await api.get(
            `${process.env.REACT_APP_API_BASE_URL}/integrations/${integrationName}/config`
        );
        return {
            name: integrationName,
            config: res?.data,
        };
    } catch (error) {
        console.error(`Error fetching integration config for ${integrationName}:`, error);
        return { name: integrationName, config: {} };
    }
};

export const useGetIntegrations = () => {
    return useApiQuery(
        ['integrations'],
        fetchIntegrations,
        {
            actions: {
                setLoading: setLoading,
                setSuccess: setIntegrations,
                setError: setError
            },
            enabled: false
        }
    );
};

export const useGetIntegrationConfig = (integrationName: string) => {
    return useApiQuery(
        ['integrationConfig', integrationName],
        () => fetchIntegrationConfig(integrationName),
        {
            actions: {
                setLoading: setLoading,
                setSuccess: setIntegrationConfig,
                setError: setError
            },
            enabled: false
        }
    );
};

export const integrationsService = {
    fetchIntegrations,
    fetchIntegrationConfig,
};

export default integrationsService;
